module.exports = __webpack_public_path__ + "static/media/ios_share_icon.cd794ab5.svg";